import superFetch from '../utils/super-fetch';

const fetchBrokers = (params) => {
  const url = '/brokersearch';
  const options = {
    method: 'GET',
    params,
  };

  return superFetch(url, options)
    .then(data => data.json());
};

const fetchSharedEmails = (params) => {
  const sharedEmailUrl = '/voucheremailsearch';
  const options = {
    method: 'GET',
    params,
  };

  return superFetch(sharedEmailUrl, options)
    .then(data => data.json());
};

const fetchBroker = (id) => {
  const url = `/brokers/${id}`;
  const options = {
    method: 'GET',
  };

  return superFetch(url, options)
    .then(data => data.json());
};

const fetchBrokersAndSharedEmails = (params) => Promise.all([
  fetchBrokers(params).catch(() => []),
  fetchSharedEmails(params).catch(() => []),
]).then(([brokers, sharedEmails]) => {
  const brokerList = Array.isArray(brokers) ? brokers : (brokers?.results || []);
  const sharedList = Array.isArray(sharedEmails) ? sharedEmails : (sharedEmails?.results || []);
  const seen = new Set(brokerList.map(b => (b.work_email || b.email || '').toLowerCase()).filter(Boolean));
  const deduped = sharedList.filter(s => {
    const email = (s.work_email || s.email || '').toLowerCase();
    return email && !seen.has(email);
  });
  return [...brokerList, ...deduped];
});

export {
  fetchBrokers,
  fetchBroker,
  fetchSharedEmails,
  fetchBrokersAndSharedEmails,
};
